<template>
  <div class="snsBlockCarousel">
    <carousel v-if="carouselVIf" :per-page="4.2">
      <slide v-for="pieceObj in blockInfo.pieceList" :key="pieceObj.piece_id" style="position:relative;" @slideclick="slideClick(pieceObj.landing_url);">
        <img :src="pieceObj.thumbnail" :title="pieceObj.landing_url" style="width:100%;height:100%;object-fit:cover;">
        <img :src="favicon[pieceObj.sns_type]" style="position:absolute;right:5px;bottom:5px;width:16px;height:16px;"/>
        <div v-if="blockEditVIf" style="text-align:right;position:absolute;bottom:2px;left:0;">
          <button @click="putPieceOrdinalno(pieceObj.piece_id, -1)" type="button" style="margin-left:2px;padding:0.2rem 0.5rem;" class="btn btn-primary"><i class="fas fa-arrow-left"/></button>
          <button @click="putPieceOrdinalno(pieceObj.piece_id, 1)" type="button" style="margin-left:2px;padding:0.2rem 0.5rem;" class="btn btn-primary"><i class="fas fa-arrow-right"/></button>
          <button @click="deletePiece(pieceObj.piece_id)" type="button" style="margin-left:2px;padding:0.2rem 0.5rem;" class="btn btn-danger"><i class="fas fa-trash"/></button>
        </div>
      </slide>
    </carousel>
  </div>
</template>
<script>
import { Carousel, Slide } from 'vue-carousel';
export default {
  components: {
    Carousel,
    Slide,
  },
  data: () => ({
    carouselVIf: false,
    blockEditVIf: false,
    blockInfo: {},
    favicon: {
      'youtube': 'https://www.youtube.com/s/desktop/c62fa080/img/favicon_32x32.png',
      'instagram': 'https://www.instagram.com/static/images/ico/favicon.ico/36b3ee2d91ed.ico',
    },
  }),
  methods: {
    getBrandboosterBlock(){ // 페이지 리스트를 API 조회하여 화면상에 출력
      this.$http
          .get('/api_home/brandbooster/block?blockId=' + this.$route.params.blockId)
          .then(obj=>{
            this.blockInfo = obj.data.blockInfo;
            this.carouselVIf = true;
          })
          .catch(err=>{
            console.warn(err.response);});
      if(this.$route.query.edit != undefined && this.$route.query.edit == 1){
        this.blockEditVIf = 1;
      }
    },
    slideClick(landing_url){
      if(this.$route.query.edit == undefined && this.$route.query.edit != 1){
        window.open(landing_url, '_blank');
      }
    },
    deletePiece(pieceId){
      this.$http
          .delete('/api_home/brandbooster/block/piece', {data: {pieceId: pieceId}})
          .then(obj=>{
            window.location.reload();
          })
          .catch(err=>{
            console.warn(err.response);
          });
    },
    putPieceOrdinalno(pieceId, direction){
      this.$http
          .put('/api_home/brandbooster/block/piece/direction', {pieceId: pieceId, direction: direction})
          .then(obj=>{
            window.location.reload();
          })
          .catch(err=>{
            console.warn(err.response);
          });
    },
  },
  mounted() {
    this.getBrandboosterBlock();
  }
}
</script>
<style>
.VueCarousel-dot-container{margin:0 !important;}
.VueCarousel-dot-container button{margin:0 !important;}
</style>